import { FC } from 'react';

import { useTranslation } from 'react-i18next';

import PageHeader from '@/components/RPageHeader';

import StyledAccessManagement from './styles';

const AccessManagement: FC = () => {
  const { t } = useTranslation();

  return (
    <StyledAccessManagement>
      <PageHeader
        title={t('organization.accessManagement.title')}
        description={t('organization.accessManagement.description')}
      />
    </StyledAccessManagement>
  );
};

export default AccessManagement;
